import { Fragment } from 'react';

import { Line } from '@react-three/drei';
import * as THREE from 'three';

export const BALL_POSITION: [number, number, number] = [0.081, 0.355, -0.045];

const ANNOTATION_LINE_THICKNESS = 1.5;
const JOINT_RADIUS = 15;
const JOINT_SEGMENTS = 10;
const JOINT_Z_OFFSET = -0.00001;

export type KeypointPosition = [number, number, number];
export type Frame = Record<string, KeypointPosition>;

type Point2D = [number, number];

type JointProps = {
    position: Point2D;
};

export function Joint({ position }: JointProps) {
    return (
        <mesh position={[position[0], position[1], JOINT_Z_OFFSET]}>
            <meshBasicMaterial color="orange" side={THREE.DoubleSide} />
            <circleGeometry args={[JOINT_RADIUS, JOINT_SEGMENTS]} />
        </mesh>
    );
}

type BoneLineProps = {
    start: Point2D;
    end: Point2D;
};

export function BoneLine({ start, end }: BoneLineProps) {
    return (
        <Line
            color={0xffffff}
            lineWidth={ANNOTATION_LINE_THICKNESS}
            points={[new THREE.Vector3(start[0], start[1], 0), new THREE.Vector3(end[0], end[1], 0)]}
        />
    );
}

interface BoneProps {
    startPoint: Point2D | undefined;
    endPoint: Point2D | undefined;
    startPointId: string | number;
    endPointId: string | number;
}

export function Bone({ startPoint, endPoint, startPointId, endPointId }: BoneProps) {
    if (!startPoint || !endPoint) {
        return null;
    }

    return (
        <Fragment key={`bone_${startPointId}_${endPointId}`}>
            <Joint position={endPoint} />
            <BoneLine start={startPoint} end={endPoint} />
        </Fragment>
    );
}
